<div class="faq fade-in" (click)="openQuestion()">
  <ul class="faq-question" [ngClass]="{'faq-question--expand': expand}">
      <li class="faq-question__head">
          <span class="faq-question__title" [innerHTML]="title | highlight:searchText"></span>
          <div class="faq-question__icon" [style.background-color]="!expand ? '#0092ED' : '#8f8f8f'" 
           [ngClass]="{'faq-question__icon--display': hideOnDesktop}">
              <i class="material-icons notranslate">{{!expand ? 'keyboard_arrow_down': 'keyboard_arrow_up'}}</i>
          </div>
      </li>
      <div class="faq-answer" [ngClass]="{'faq-answer--display': expand}">
          <p class="faq-answer__text" [innerHTML]="answer | highlight:searchText"></p>
      </div>
  </ul>
</div>